import React, { useEffect, useRef, useState } from 'react';
import { COLLA } from '../../../utils/utils';
import { buildEventAppSchemeUrl } from '../../../utils/eventDeepLinks';
import Chevron from './Chevron';

// Opens the event in the app, with its form open (mobileapp DeepLinking.js looks
// the event up by its id, whatever the type in the link). Without the app the
// link does nothing: after a moment the card says so, and to answer here.
const NOT_OPENED_MS = 1500;

const OpenInApp = ({ evId, colla = COLLA }) => {
  const [notOpened, setNotOpened] = useState(false);
  const timer = useRef(null);
  const appUrl = buildEventAppSchemeUrl({ colla, eventType: 'activitat', eventId: evId });

  useEffect(() => {
    // The app came to the front: the page went to the background
    const onHidden = () => {
      if (document.hidden) clearTimeout(timer.current);
    };
    document.addEventListener('visibilitychange', onHidden);
    return () => {
      document.removeEventListener('visibilitychange', onHidden);
      clearTimeout(timer.current);
    };
  }, []);

  if (!appUrl) return null;
  return (
    <>
      <a
        className="form-row-button form-open-app"
        href={appUrl}
        onClick={() => {
          setNotOpened(false);
          clearTimeout(timer.current);
          timer.current = setTimeout(() => setNotOpened(true), NOT_OPENED_MS);
        }}
      >
        <span>Obre-ho a l'app</span>
        <Chevron />
      </a>
      {notOpened ? (
        <p className="form-open-app-hint">No s'ha obert? Potser no tens l'app: respon des de la web.</p>
      ) : null}
    </>
  );
};

export default OpenInApp;
